import { createStore } from "vuex"

import common from "./modules/common"
import visitor from "./modules/visitor"
import msgCenter from './modules/msgCenter.js'
import studentLeave from './modules/studentLeave.js'
import official from './modules/official.js'
import repair from './modules/repair.js'

export default createStore({
  state: () => ({
    freshTimestamp: '',
    exploreName: "WeChatMiniProgram",
    userType: "teacher", // 仅用于dd端 区别用户身份
    token: "",
    // toekn:'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2NhY2hlX2tleSI6InVzZXJfY2FjaGVfa2V5Ond4MjAyMjAzOjEyNDA6ZGQzODEzYTItZWEzZi00YTZlLWJmZjUtZTIzMmZhZDBkZmVjIiwibG9naW5fdG9rZW5fa2V5IjoiMTFhNzI5MGEtOWRhNS00YzgzLWE5ZGItNjM3YThhZGU0Y2ExIn0.GgSCOGuCySsMfn33nKMcvlKEAo8ZOIdjfU9UNuoi_XmsLdgvdMpldWxJxp7KdHjWjt1jcT5Qn64Xs-1wYS7E9A',
    // userName: "xxp",
    // schoolCode: "wx202203",
    // idNumber: "130133199109050371",
    // phone: "13175109117",
    userName: "",
    classId:"",
    schoolName: "",
    idNumber: "",
    phone: "",
    schoolCode: "",
    userId: '',
    userIndex: '',
    studentUserIndex: '',
    studentName: '',
    studentUserId: '',
    isLogin: true,
    flagFirstInfo: true,
    persionListSelected: [],
    persionSelectedPage: {
      moduleName: '',
      data: []
    }
  }),
  getters: {
    hasNavHeader(state) {
      let exploreName = state.exploreName
      // 阿里系不需要导航头
      return !(
        exploreName === "DingTalkWeb" ||
        exploreName === "DingTalkMini" ||
        exploreName === "Alipay" ||
        exploreName === "WeChatMiniProgram"
      )
    },
    plateformType(state) {
      let exploreName = state.exploreName
      if (exploreName == "DingTalkMini") {
        return "DingTalkMini"
      } else if (exploreName == "WeChatMiniProgram") {
        return "WeChatMiniProgram"
      } else {
        // return "DingTalkMini"
        return "webapp"
      }
    },
  },
  mutations: {
    setFreshTimestamp(state, timestamp) {
      state.freshTimestamp = timestamp
    },
    setExploreName(state, payload) {
      state.exploreName = payload
    },
    setUserName(state, payload) {
      state.userName = payload
    },
    setStudentUserIndex(state, payload) {
      state.studentUserIndex = payload
    },
    setStudentName(state, payload) {
      state.studentName = payload
    },
    setStudentUserId(state, payload) {
      state.studentUserId = payload
    },
    setSchoolCode(state, payload) {
      state.schoolCode = payload
    },
    setSchoolName(state, payload) {
      state.schoolName = payload
    },
    setPhone(state, payload) {
      state.phone = payload
    },
    setClassId(state, payload) {
      state.classId = payload
    },
    setIdNumber(state, payload) {
      state.idNumber = payload
    },
    setPlateformType(state, payload) {
      state.plateformType = payload
    },
    setUserType(state, payload) {
      state.userType = payload
    },
    setUserId(state, payload) {
      state.userId = payload
    },
    setUserIndex(state, payload) {
      state.userIndex = payload
    },
    setIsLogin(state, payload) {
      state.isLogin = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setFlagFirstInfo(state, payload) {
      state.flagFirstInfo = payload
    },
    setPersionListSelected(state, payload) {
      state.persionListSelected = payload
    },
    setPersionSelectedPage(state, payload) {
      state.persionSelectedPage = payload
    },

  },
  actions: {},
  modules: {
    common,
    visitor,
    msgCenter,
    studentLeave,
    repair,
    official
  },
})
